module.exports = __webpack_public_path__ + "img/ko_redpacket.07472454.png";